import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { NoCache } from './no-cache';
import { WebCacheStorage } from './web-cache-storage';
var ResponseCacheProviderResolver = /*#__PURE__*/function () {
  function ResponseCacheProviderResolver() {
    _classCallCheck(this, ResponseCacheProviderResolver);
  }
  _createClass(ResponseCacheProviderResolver, null, [{
    key: "resolve",
    value:
    /**
     * Returns the cache provider based on the given cache configuration
     *
     * @param cacheConfig The cache configuration to use
     * @returns The cache provider
     */
    function resolve(cacheConfig) {
      if (cacheConfig) {
        return new WebCacheStorage(cacheConfig);
      }
      return new NoCache();
    }
  }]);
  return ResponseCacheProviderResolver;
}();
export { ResponseCacheProviderResolver as default };